import autobind from "autobind-decorator";
import { observer } from "mobx-react";
import React from "react";
import { Link } from "react-router";
import styled, { css } from "styled-components";

import Style from "@client/utils/Style";
import { User } from "@typings/Identity";

import userWhiteImage from "./images/user-white.svg";
import userImage from "./images/user.svg";

const Wrapper = styled.div`
  position: relative;
`;
const Icon = styled.div<{ white?: boolean }>`
  position: relative;
  cursor: pointer;
  width: 32px;
  height: 32px;
  transition: all ${Style.animations.swift};
  background: url("${props => (props.white ? userWhiteImage : userImage)}")
    no-repeat center;

  &:hover {
    opacity: 0.8;
  }
`;
const List = styled.div`
  background: ${Style.palette.grayscale[1]};
  border-radius: ${Style.borderRadius};
  position: absolute;
  right: 0;
  top: 45px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  z-index: 10;
`;
const ListItem = styled.div`
  padding-top: 8px;
`;

const Label = styled.div<{ selectable?: boolean }>`
  display: inline-block;
  white-space: nowrap;
  ${props =>
    props.selectable
      ? css`
          cursor: pointer;
          &:hover {
            color: ${Style.palette.primary};
          }
        `
      : ""}
`;

const ListHeader = styled.div`
  position: relative;

  &:after {
    content: " ";
    position: absolute;
    width: 10px;
    height: 10px;
    background: ${Style.palette.grayscale[1]};
    border: 1px solid ${Style.palette.grayscale[1]};
    border-color: transparent transparent ${Style.palette.grayscale[1]}
      ${Style.palette.grayscale[1]};
    transform: rotate(135deg);
    right: -6px;
    top: -22px;
    transition: all ${Style.animations.swift};
  }
`;
const Username = styled(Link)`
  font-size: 16px;
  color: ${Style.palette.black};
  text-decoration: none;
  ${props => (props.to === "" ? "pointer-events: none;" : "")}
  &:hover {
    color: ${Style.palette.primary};
  }
`;
const Email = styled.div`
  font-size: 10px;
  color: ${Style.palette.grayscale[4]};
  margin-top: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid ${Style.palette.grayscale[3]};
`;

type DictItem = { label: string; value: string };
type Props = {
  onItemClick: (item: DictItem) => void;
  user?: User | null;
  white?: boolean;
  className?: string;
};
type State = {
  showDropdownList: boolean;
};
@observer
class DropdownUser extends React.Component<Props, State> {
  state: State = {
    showDropdownList: false,
  };

  itemMouseDown = false;

  componentDidMount() {
    window.addEventListener("mousedown", this.handlePageClick, false);
  }

  componentWillUnmount() {
    window.removeEventListener("mousedown", this.handlePageClick, false);
  }

  handleItemClick(item: DictItem) {
    if (this.props.onItemClick) {
      this.props.onItemClick(item);
    }

    this.setState({ showDropdownList: false });
  }

  @autobind
  handlePageClick() {
    if (!this.itemMouseDown) {
      this.setState({ showDropdownList: false });
    }
  }

  handleButtonClick() {
    this.setState({ showDropdownList: !this.state.showDropdownList });
  }

  renderNoUser() {
    if (this.props.user) {
      return null;
    }

    return <Label>No signed in user</Label>;
  }

  renderListHeader() {
    if (!this.props.user) {
      return null;
    }

    return (
      <ListHeader
        onMouseDown={() => {
          this.itemMouseDown = true;
        }}
        onMouseUp={() => {
          this.itemMouseDown = false;
        }}
      >
        <Username to="">{this.props.user.name}</Username>
        <Email />
      </ListHeader>
    );
  }

  renderList() {
    if (!this.state.showDropdownList) {
      return null;
    }

    const items = [
      {
        label: "Change Password",
        value: "changepassword",
      },
      {
        label: "Sign Out",
        value: "signout",
      },
    ];
    const list = (
      <List>
        <ListHeader>
          {this.renderListHeader()}
          {this.renderNoUser()}
        </ListHeader>
        {this.props.user
          ? items.map(item => {
              return (
                <ListItem
                  key={item.value}
                  onMouseDown={() => {
                    this.itemMouseDown = true;
                  }}
                  onMouseUp={() => {
                    this.itemMouseDown = false;
                  }}
                >
                  <Label
                    selectable
                    onClick={() => {
                      this.handleItemClick(item);
                    }}
                  >
                    {item.label}
                  </Label>
                </ListItem>
              );
            })
          : null}
      </List>
    );

    return list;
  }
  render() {
    return (
      <Wrapper className={this.props.className}>
        <Icon
          onMouseDown={() => {
            this.itemMouseDown = true;
          }}
          onMouseUp={() => {
            this.itemMouseDown = false;
          }}
          onClick={() => this.handleButtonClick()}
          white={this.props.white}
        />
        {this.renderList()}
      </Wrapper>
    );
  }
}

export default DropdownUser;
